// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"6d143f3e4d2208f9c6c2","966":"250840c802a98abb21a2"}[chunkId] + ".js";
};